import React from 'react';
import { object } from 'prop-types';

function DeleteModalContent({ data: { first_name, last_name, email } }) {
  return (
    <>
      <div className="employees-right__group-wrapper">
        <div className="employees-right__group-label">Dane konta</div>
      </div>
      <div className="employees-right__container">
        <div className="employees-right__field-wrapper">
          <div className="employees-right__field-label">Imię</div>
          <div className="employees-right__input">{first_name}</div>
        </div>
        <div className="employees-right__field-wrapper">
          <div className="employees-right__field-label">Nazwisko</div>
          <div className="employees-right__input">{last_name}</div>
        </div>
      </div>
      <div className="employees-right__container">
        <div className="employees-right__field-wrapper">
          <div className="employees-right__field-label">Adres email</div>
          <div className="employees-right__input">{email}</div>
        </div>
      </div>
    </>
  );
}

DeleteModalContent.propTypes = {
  data: object.isRequired,
};

export default DeleteModalContent;
